// extracted by mini-css-extract-plugin
module.exports = {"cell":"CellProductHeader_cell__XJX1m","label":"CellProductHeader_label__WSNUI","skeleton":"CellProductHeader_skeleton__VmZ1Q"};